import React from "react";

const ThemeComponent = ({
  updateTheme,
  themeClass,
  themeName,
  themeFontColor,
  isPaying,
  pageDetails,
  themePreview,
}) => {
  return (
    <div
      className="theme"
      onClick={() => {
        updateTheme(themeClass, themeFontColor);
      }}
    >
      <div
        className={`${
          !pageDetails.HasCustomTheme && pageDetails.ThemeClass === themeClass
            ? `theme-style ${themeClass} selected`
            : `theme-style ${themeClass}`
        }`}
      >
        <img src={themePreview} alt="theme preview" className="theme-preview" />
      </div>
      <div className="theme-name">{themeName}</div>
    </div>
  );
};

export default ThemeComponent;
